import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CalendarCommonService {
  private readonly _dailyTaskData = new BehaviorSubject<any>(null);

  get dailyTaskData(): Observable<any> {
    return this._dailyTaskData.asObservable();
  }

  set dailyTaskData(data: any) {
    this._dailyTaskData.next(data);
  }

  clearDailyTaskData(): void {
    this._dailyTaskData.next(null);
  }
}
